import { appraisal_report_type_enum } from '@predium/enums';
import { Trans, getI18n } from 'react-i18next';

export const translateAppraisalReportTypeEnum = (enumValue: appraisal_report_type_enum) => {
  switch (enumValue) {
    case appraisal_report_type_enum.STATUTORY_MARKET_VALUE:
      return <Trans i18nKey="Enum_AppraisalReportTypeEnum-STATUTORY_MARKET_VALUE" />;
    case appraisal_report_type_enum.MORTGAGE_LENDING_VALUE:
      return <Trans i18nKey="Enum_AppraisalReportTypeEnum-MORTGAGE_LENDING_VALUE" />;
    case appraisal_report_type_enum.MARKET_VALUE:
      return <Trans i18nKey="Enum_AppraisalReportTypeEnum-MARKET_VALUE" />;
  }
};

export const translateAppraisalReportTypeEnum_dynamic = (enumValue: appraisal_report_type_enum) => {
  const t = getI18n().t;
  switch (enumValue) {
    case appraisal_report_type_enum.STATUTORY_MARKET_VALUE:
      return t('Enum_AppraisalReportTypeEnum-STATUTORY_MARKET_VALUE');
    case appraisal_report_type_enum.MORTGAGE_LENDING_VALUE:
      return t('Enum_AppraisalReportTypeEnum-MORTGAGE_LENDING_VALUE');
    case appraisal_report_type_enum.MARKET_VALUE:
      return t('Enum_AppraisalReportTypeEnum-MARKET_VALUE');
  }
};
